import { Component, OnInit, Input } from '@angular/core';
import { Customer } from '../../models/customer.interface';
import { CustomerService } from '../../../customer/services/customer.service';
import { CustomerType } from '../../models/customer.type.interface';

@Component({
  selector: 'app-customer-info-summary-mobile',
  templateUrl: './customer-info-summary-mobile.component.html',
  styleUrls: ['./customer-info-summary-mobile.component.scss']
})
export class CustomerInfoSummaryMobileComponent implements OnInit {
  customer: Customer;
  customerType: CustomerType;
  types: CustomerType[];

  constructor(private customerService: CustomerService) { }

  ngOnInit(): void {

  }


  @Input()
  public set customerInfo(value: Customer) {
    if (value) {
      this.customer = value;

      if (this.customer.customerType != null) {
        this.customerType == this.customer.customerType
    }
    else
      if (this.customer.customerType_ID != null) {
        this.customerService.getCustomerTypes()
          .subscribe({
            next: (data) => {
              this.types = data;
              this.customerType = this.types.find(ct => ct.customerType_ID == this.customer.customerType_ID)
            }
          });

      }
    }
  }
}
